import { render, staticRenderFns } from "./MoleculeWorkloadItem.vue?vue&type=template&id=032d826e&scoped=true&"
import script from "./MoleculeWorkloadItem.vue?vue&type=script&lang=js&"
export * from "./MoleculeWorkloadItem.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeWorkloadItem.vue?vue&type=style&index=0&id=032d826e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d826e",
  null
  
)

export default component.exports